module.exports = __webpack_public_path__ + "img/iso.52a7dcce.png";